var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import client from "@irati/utils/services/apollo";
import PBService from "@irati/utils/services";
import listFormat from "@irati/utils/services/graph/utils/listFormat";
import archiveDealRedemptionMutation from "./mutations/archiveDealRedemption";
import toggleIsUsedMutation from "./mutations/toggleRedemptionIsUsed";
import dealsErrorHandler from "./errors/dealsErrorHandler";
import { query as dealRedemptionListQuery } from "../apollo/query/DealRedemptionList";
import dealRedemptionsQuery, { redemptionListQueryKey } from "./queries/dealRedemptions";
import dealRedemptionQuery, { redemptionQueryKey } from "./queries/dealRedemption";
var DealRedemptionService = /** @class */ (function (_super) {
    __extends(DealRedemptionService, _super);
    function DealRedemptionService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DealRedemptionService.prototype.get = function (redemptionId, options) {
        if (options === void 0) { options = {}; }
        var variables = { uuid: redemptionId };
        return client.query(__assign(__assign({}, options), { query: dealRedemptionQuery, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data[redemptionQueryKey];
        });
    };
    DealRedemptionService.prototype.list = function (variables, options) {
        if (options === void 0) { options = {}; }
        return client.query(__assign(__assign({}, options), { query: dealRedemptionsQuery, variables: variables })).then(function (_a) {
            var data = _a.data;
            return listFormat(data[redemptionListQueryKey]);
        });
    };
    DealRedemptionService.prototype.archive = function (redemptionId, ifMatch, options) {
        if (options === void 0) { options = {}; }
        var variables = { redemptionId: redemptionId, ifMatch: ifMatch };
        return client.mutate(__assign(__assign({}, options), { mutation: archiveDealRedemptionMutation, variables: variables })).then(function () { return true; });
    };
    DealRedemptionService.prototype.toggleIsUsed = function (redemption, _a, options) {
        var _b = (_a === void 0 ? {} : _a).refetchAll, refetchAll = _b === void 0 ? false : _b;
        if (options === void 0) { options = {}; }
        var uuid = redemption.uuid, isUsed = redemption.isUsed, etag = redemption.etag;
        var refetchQueries = [
            {
                query: dealRedemptionListQuery,
                variables: { isUsed: !isUsed }
            }
        ];
        if (refetchAll) {
            refetchQueries.push({
                query: dealRedemptionListQuery,
                variables: { isUsed: isUsed }
            });
        }
        return client
            .mutate(__assign(__assign({}, options), { mutation: toggleIsUsedMutation, variables: { uuid: uuid, isUsed: isUsed, etag: etag }, refetchQueries: refetchQueries }))
            .then(function (_a) {
            var data = _a.data;
            return data.toggleRedemptionIsUsed;
        });
    };
    return DealRedemptionService;
}(PBService));
export default new DealRedemptionService({ errorHandlers: [dealsErrorHandler] });
